export default __webpack_public_path__ + "static/media/smartphone.22bc3b27.png";